import { FormikProps } from "formik";
import { useContext } from "react";
import { LicenseListFilter } from "../../../../../generated/data-contracts";
import { FormikUtils } from "../../../../../utils";
import { isMobileView } from "../../../../shared/appStates/appStates";
import { FilterActions } from "../../../../shared/components/form";
import { AvisInputTextWithFilterType } from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ILicensesFilterFormProps {
  bag: FormikProps<LicenseListFilter>;
  loading: boolean;
  filtered: boolean;
}

export function LicensesFilterForm(props: Readonly<ILicensesFilterFormProps>) {
  const { bag, loading, filtered } = props;
  const { res } = useContext(AvisContext);

  const classNameSecondColumn = isMobileView.value ? "col-8" : "col-6";
  return (
    <>
      <div className="row">
        <AvisInputTextWithFilterType<LicenseListFilter>
          className={classNameSecondColumn}
          label={res("licensees_License_label_Number")}
          bag={bag}
          bagField="licenseNumber"
          bagFieldFilterType="licenseNumberFilterType"
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <div className="row">
        <AvisInputTextWithFilterType<LicenseListFilter>
          className={classNameSecondColumn}
          label={res("licensees_License_label_ObjectName")}
          bag={bag}
          bagField="licenseObjectName"
          bagFieldFilterType="licenseObjectNameFilterType"
          disabled={loading}
          minLength={2}
          maxLength={200}
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, bag.submitForm)}
        />
      </div>
      <FilterActions
        bag={bag}
        loading={loading}
        filtered={filtered}
        res={res}
      />
    </>
  );
}
